export default "__VITE_ASSET__C0FS8NdI__"